<template>
  <div class="app-content">
    <app-breadcrumb v-on="breadcrumbOn">
      <slot name="breadcrumb-custom"></slot>
    </app-breadcrumb>
    <div class="app-content__body">
      <div
        class="app-content__main-content"
        :class="appContentClass"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"
  @import "side-menu-sizes"

  .app-content
    display: flex
    flex: 1
    flex-direction: column
    @media print
      display: initial
    &__body
      display: flex
      flex: 1 0 auto
      @media print
        display: initial
    &__main-content
      display: flex
      flex-direction: column
      padding: 20px 10px
      width: 100%
      @media print
        display: initial
      &_no-padding
        padding: 0
    +media-min-sm()
      &__main-content
        padding: 20px 20px
    +media-min-md()
      &__main-content
        padding: 20px 40px
    +media-min-lg()
</style>

<script>
import optimizedResizeEvent from '@/services/optimizedResizeEvent';
import ThemeService from '@/services/themeService';
import AppBreadcrumb from './AppBreadcrumb';
import SideMenuSizes from './sideMenuSizes';

export default {
  components: {
    AppBreadcrumb,
  },
  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
    sideMenu: Array,
    /**
     * Permitir colapsar o menu lateral.
     * Em telas pequenas será automaticamente colapsável.
     */
    collapsableSideMenu: {
      type: Boolean,
      default: false,
    },
    /**
     * Tamanho do menu lateral. Varia de 1 até o tamanho máximo (ver SideMenuSize.js).
     */
    sideMenuSize: {
      type: Number,
      default: 2,
    },
    breadcrumbOn: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      collapsedSideMenu: this.isMaxMd(),
      collapsableSideMenuByScreenSize: this.isMaxMd(),
      resizeListenerAdded: false,
    };
  },
  methods: {
    isMaxMd() {
      return ThemeService.isScreenSize('max-md');
    },
    onScreenResize() {
      this.collapsableSideMenuByScreenSize = this.isMaxMd();
    },
  },
  watch: {
    collapsableSideMenuByScreenSize(newValue) {
      this.collapsedSideMenu = newValue;
    },
  },
  computed: {
    sideMenuClass() {
      return SideMenuSizes.getSizeClasses(
        'app-content__side-menu',
        this.collapsedSideMenu,
        this.sideMenuSize,
      );
    },
    appContentClass() {
      return {
        'app-content__main-content_no-padding': this.noPadding,
        ...this.sideMenu
          ? SideMenuSizes.getSizeClasses(
            'app-content__main-content_side-menu',
            this.collapsedSideMenu,
            this.sideMenuSize,
          )
          : null,
      };
    },
    shouldBeCollapsableSideMenu() {
      return this.collapsableSideMenu || this.collapsableSideMenuByScreenSize;
    },
  },
  created() {
    if (this.sideMenu) {
      this.resizeListenerAdded = true;
      optimizedResizeEvent.on(this.onScreenResize, this);
    }
  },
  beforeDestroy() {
    if (this.resizeListenerAdded) {
      optimizedResizeEvent.off(this.onScreenResize, this);
    }
  },
};
</script>
